import * as signalR from '@microsoft/signalr'
import { useAuthStore } from '../store/authStore'
import type { Notificacao } from '../types'

const BASE_URL = import.meta.env.VITE_API_URL

let connection: signalR.HubConnection | null = null
let assinantes = 0

/** Conecta no hub uma vez só (mesmo com vários componentes chamando); desconecta quando o último desmonta. */
export function conectarNotificacoes(aoReceber: (n: Notificacao) => void): () => void {
  assinantes++

  if (!connection) {
    connection = new signalR.HubConnectionBuilder()
      .withUrl(`${BASE_URL}/hubs/notificacoes`, {
        accessTokenFactory: () => useAuthStore.getState().accessToken ?? '',
      })
      .withAutomaticReconnect()
      // O nível padrão (Information) imprime a URL de conexão no console, com o token de acesso dentro —
      // um vazamento de sessão pra qualquer um com acesso ao console do navegador.
      .configureLogging(signalR.LogLevel.Warning)
      .build()
    connection.start().catch(() => {
      // Sem tempo real por enquanto: a lista continua funcionando por busca normal.
    })
  }

  connection.on('notificacao', aoReceber)

  return () => {
    connection?.off('notificacao', aoReceber)
    assinantes--
    if (assinantes <= 0) {
      connection?.stop()
      connection = null
      assinantes = 0
    }
  }
}
